


























import { ElTable } from "element-ui/types/table";
import { Component, Mixins } from "vue-property-decorator";
import { CommentTableMixin } from "./mixins";

@Component({})
export default class CommentNarrowTable extends Mixins(CommentTableMixin) {
  mounted() {
    // それなりの長文のコメントを表示するとき、右側に妙な余白が表示される
    // 一瞬だけスクロールバーが表示されて、その横幅のぶんが引かれた横幅で表示されてしまっている模様
    // 再描画させることで対応している
    this.$nextTick(() => {
      this.refreshTableLayout();
    });
  }

  activated() {
    this.refreshTableLayout();
  }

  $refs!: {
    commentNarrowTable: ElTable,
  };

  private refreshTableLayout(): void {
    this.$doWhenValid(t => t.doLayout(), this.$refs.commentNarrowTable);
  }
}
